module.exports = __webpack_public_path__ + "static/media/Maven_6622.7b18e576.jpg";